/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// Uses @compiled/react because lineHeight and space-token width/height are not allowed by the strict @atlaskit/css types.
import { cssMap as compiledCssMap } from '@compiled/react';

import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	buttonWrapper: {
		position: 'relative',
	},
});

const styledCloseStyles = compiledCssMap({
	close: {
		backgroundColor: 'transparent',
		borderWidth: 0,
		borderStyle: 'none',
		height: token('space.300'),
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- preserving the original non-token lineHeight during the styled-components migration
		lineHeight: 1,
		outlineWidth: 0,
		paddingTop: 0,
		paddingRight: 0,
		paddingBottom: 0,
		paddingLeft: 0,
		position: 'absolute',
		right: token('space.negative.050'),
		top: '50%',
		marginTop: token('space.negative.150'),
		width: token('space.300'),
	},
});

export const ButtonWrapper = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.buttonWrapper} {...props}>
		{children}
	</div>
);

export const StyledClose = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styledCloseStyles.close} {...props}>
		{children}
	</div>
);
